import React from 'react';
import { AuthLayout } from '../auth-layout.component';
import { ConfirmAccount } from './confirm-account.component';

export const ConfirmAccountScreen = (): React.ReactElement => {
    return <AuthLayout component={<ConfirmAccount />} />;
};
